"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingTransactionArtifactKindToJSON = exports.BillingTransactionArtifactKindFromJSONTyped = exports.BillingTransactionArtifactKindFromJSON = exports.BillingTransactionArtifactKind = void 0;
/**
 * The type of the artifact related with the billing transaction (.e.g. Appointment)
 * @export
 * @enum {string}
 */
var BillingTransactionArtifactKind;
(function (BillingTransactionArtifactKind) {
    BillingTransactionArtifactKind["Appointment"] = "appointment";
    BillingTransactionArtifactKind["BillableRequest"] = "billableRequest";
})(BillingTransactionArtifactKind || (exports.BillingTransactionArtifactKind = BillingTransactionArtifactKind = {}));
function BillingTransactionArtifactKindFromJSON(json) {
    return BillingTransactionArtifactKindFromJSONTyped(json, false);
}
exports.BillingTransactionArtifactKindFromJSON = BillingTransactionArtifactKindFromJSON;
function BillingTransactionArtifactKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BillingTransactionArtifactKindFromJSONTyped = BillingTransactionArtifactKindFromJSONTyped;
function BillingTransactionArtifactKindToJSON(value) {
    return value;
}
exports.BillingTransactionArtifactKindToJSON = BillingTransactionArtifactKindToJSON;
//# sourceMappingURL=BillingTransactionArtifactKind.js.map